namespace $.$$ {

	$mol_style_attach( '$shm_projects_tasks_busy_spin', `
		@keyframes shm_projects_tasks_busy_spin {
			to { transform: rotate(360deg); }
		}
		[shm_projects_tasks_task_busy] {
			box-sizing: border-box;
			width: 0.8rem;
			height: 0.8rem;
			border: 2px solid currentColor;
			border-right-color: transparent;
			border-radius: 50%;
			animation: shm_projects_tasks_busy_spin 0.8s linear infinite;
		}
	` )

	$mol_style_define( $shm_projects_tasks, {
		List: {
			flex: { basis: '22rem', grow: 0, shrink: 0 },
		},
		Empty: {
			color: $mol_theme.shade,
		},
		Task_busy: {
			flex: { grow: 0, shrink: 0 },
			color: $shm_theme.active,
		},
		Task_updated: {
			width: '0.75rem',
			color: $mol_theme.current,
			font: { size: '0.65rem' },
		},
	} )

}
